<!-- ICON -->
@if (localDevice?.hasBeacon) {
  <mat-icon style="margin: 0.5rem; flex-shrink: 0">mode_standby</mat-icon>
} @else {
  <p [class]="(localDevice?.isPrivacy ? 'inactive-device ' : '') + localDevice?.deviceStatusClass"></p>
}

<!-- INFO -->
<div class="device-card_content">
  <div class="content_title">
    <h1 [matTooltip]="localDevice?.registration" ubiShowIfTruncated>{{ localDevice?.registration }}</h1>
    @if (localDevice?.location_date) {
      <p>{{ localDevice?.location_date | dynamicDate: 'short' }}</p>
    }
  </div>

  @if (poi) {
    <div class="device-card-poi-info">
      <span class="device-poi poi_item poi_{{ poi.icon }} marg-right-five"></span>
      <p>
        {{ poi.label }}
        @if (zoi) {
          ({{ zoi.label }})
        }
      </p>
    </div>
  } @else {
    <p>
      {{ localDevice?.address }}
      @if (zoi) {
        <span>({{ zoi.label }})</span>
      }
    </p>
  }

  @if (driver) {
    <chip class="device-card_driver-chip">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px">record_voice_over</mat-icon>
      <span class="device-card_driver-chip-label" [matTooltip]="driver.label" ubiShowIfTruncated>
        {{ driver.label }}
      </span>
    </chip>
  }
</div>
